// extracted by mini-css-extract-plugin
export default {"wrap":"styles_wrap__SAUkE","wrap__error":"styles_wrap__error__2zlD7","icon":"styles_icon__IMQBe","closeIcon":"styles_closeIcon__F5E3e"};